<template>
  <div class="cate">
    <table border="1">
      <tr>
        <td>分类：</td>
        <td>
          <show-more v-model="classifyList"
                     :showName="'name'"
                     :defaultIndex=productCategoryIdIIndex
                     @change="changeClassify"></show-more>
        </td>
      </tr>
      <tr v-if="selectClassify">
        <td>{{selectClassify.name}}：</td>
        <td>
          <show-more v-model="childClassifyList"
                     :showName="'name'"
                     :defaultIndex=productCategoryIdIndex
                     @change="changeChildClassify"></show-more>
        </td>
      </tr>
      <tr v-if="childClassify">
        <td>{{childClassify.name}}：</td>
        <td>
          <show-more v-model="threeClassifyList"
                     :showName="'name'"
                     :defaultIndex=productCategoryIdIiiIndex
                     @change="changeThreeClassify"></show-more>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {getClassifyList } from '@/api/goods'
  import ShowMore from '@/components/ShowMore'
  export default {
    name: 'index',
    components: {
      ShowMore
    },
    data() {
      return {
        classifyList: [],
        selectClassify: null,
        childClassify: null,
        childClassifyList: [],
        threeClassifyList: [],
        productCategoryIdIIndex: null,
        productCategoryIdIndex: null,
        productCategoryIdIiiIndex: null,
        params: {
          productCategoryIdI: null,
          productCategoryId: null,
          productCategoryIdIii: null
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.params.productCategoryIdI = this.$route.query.productCategoryIdI
        this.params.productCategoryId = this.$route.query.productCategoryId
        this.params.productCategoryIdIii = this.$route.query.productCategoryIdIii
        getClassifyList({ level: 1 }).then(res => {
          this.classifyList = res.data
          this.classifyList.unshift({
            name: '全部',
            platCatgegoryId: null
          })
          window.console.log('this.classifyList', this.classifyList)
          let index = this.classifyList.findIndex((item) => item.platCatgegoryId == this.params.productCategoryIdI);
          if (index != -1) {
            window.console.log('index', index)
            this.productCategoryIdIIndex = index
          } else {
            this.productCategoryIdIIndex = 0
          }
          this.changeClassify(this.productCategoryIdIIndex)
        }).catch(err => {
          this.$emit('selectCategory',this.params)
        })
      },
      changeClassify(index) {
        this.selectClassify = this.classifyList[index]
        window.console.log('selectClassify', this.selectClassify)
        this.params.productCategoryIdI = this.selectClassify.platCatgegoryId
        if(!index) {
          this.params.productCategoryId = null
          this.params.productCategoryIdIii = null

        }
        getClassifyList({
          level: 2,
          id: this.selectClassify.platCatgegoryId
        }).then(res => {
          this.childClassifyList = res.data
          this.childClassifyList.unshift({
            name: '全部',
            platCatgegoryId: null
          })
          let index = this.childClassifyList.findIndex((item) => item.platCatgegoryId == this.params.productCategoryId);
          console.log(' this.params.productCategoryId', this.params.productCategoryId)
          if (index != -1) {
            this.productCategoryIdIndex = index
          } else {
            this.productCategoryIdIndex = 0
          }
          this.changeChildClassify(this.productCategoryIdIndex)
        }).catch(err => {
          this.$emit('selectCategory',this.params)
        })
      },
      changeChildClassify(index) {
        this.childClassify = this.childClassifyList[index]
        this.params.productCategoryId = this.childClassify.platCatgegoryId
        getClassifyList({
          level: 3,
          id: this.childClassify.platCatgegoryId
        }).then(res => {
          this.threeClassifyList = res.data
          this.threeClassifyList.unshift({
            name: '全部',
            platCatgegoryId: null
          })
          let index = this.threeClassifyList.findIndex((item) => item.platCatgegoryId == this.params.productCategoryIdIii);
          if (index != -1) {
            this.productCategoryIdIiiIndex = index
          } else {
            this.productCategoryIdIiiIndex = 0
          }
        }).catch(err => {

        })
        this.$emit('selectCategory',this.params)
      },
      changeThreeClassify(index) {
        this.params.productCategoryIdIii = this.threeClassifyList[index].platCatgegoryId
        this.$emit('selectCategory',this.params)
      },
    }
  }
</script>

<style scoped>
.cate{
  margin: 0;
}
</style>
